export default __webpack_public_path__ + "static/chord-6892870901033703cc9c2a2391b609ed.png";